module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_hy30@2x.0ce52b0f.png";